import { render, staticRenderFns } from "./ItemRecipe.vue?vue&type=template&id=996a135a&scoped=true&"
import script from "./ItemRecipe.vue?vue&type=script&lang=js&"
export * from "./ItemRecipe.vue?vue&type=script&lang=js&"
import style0 from "./ItemRecipe.vue?vue&type=style&index=0&id=996a135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a135a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VExpandTransition,VFadeTransition,VIcon,VRadio,VRadioGroup,VRow,VTooltip})
